import { makeAutoObservable } from 'mobx'

class EssaySummaryStore {
	updatedAt = null
	essays = []
	byTargetId = {}
	loadStatus = 'idle'
	lastEtag = null

	constructor() {
		makeAutoObservable(this, {}, { autoBind: true })
	}

	setPayload(payload) {
		const nextEtag = payload?.updatedAt || null
		if (nextEtag && nextEtag === this.lastEtag) {
			this.loadStatus = 'success'
			return false
		}
		this.lastEtag = nextEtag
		this.updatedAt = nextEtag
		this.essays = Array.isArray(payload?.essays) ? payload.essays : []
		this.byTargetId = payload?.byTargetId || {}
		this.loadStatus = 'success'
		return true
	}

	setLoading() {
		this.loadStatus = 'loading'
	}

	setError() {
		this.loadStatus = 'error'
	}

	/** Optimistic: counselor opened essay drawer (matches dashboard markEssaySeenLocal). */
	markEssaySeen(essayId, { versionId } = {}) {
		const eid = String(essayId || '').trim()
		const vid = String(versionId || '').trim()
		if (!eid && !vid) return

		let changed = false
		const nextEssays = this.essays.map(essay => {
			const matchesEssay = eid && String(essay.id) === eid
			const matchesVersion = vid && String(essay.displayVersionId) === vid
			if (!matchesEssay && !matchesVersion) return essay
			if (!essay.isNew) return essay
			changed = true
			return { ...essay, isNew: false }
		})
		if (changed) {
			this.essays = nextEssays
		}
	}

	clearEssayUnreadFeedback(essayId, { subtract } = {}) {
		const eid = String(essayId || '').trim()
		if (!eid) return

		let changed = false
		const nextEssays = this.essays.map(essay => {
			if (String(essay.id) !== eid) return essay
			const current = Number(essay.unreadFeedbackCount) || 0
			const next =
				subtract == null
					? 0
					: Math.max(0, current - Math.max(0, Number(subtract) || 0))
			if (next === current) return essay
			changed = true
			return { ...essay, unreadFeedbackCount: next }
		})
		if (changed) {
			this.essays = nextEssays
		}
	}

	get aggregateByTargetId() {
		const map = new Map()
		Object.entries(this.byTargetId || {}).forEach(([targetId, meta]) => {
			if (meta?.aggregateStatus) {
				map.set(String(targetId), meta.aggregateStatus)
			}
		})
		return map
	}

	get essaysByTargetId() {
		const map = new Map()
		this.essays.forEach(essay => {
			const key = String(essay?.applicationTargetId || '').trim()
			if (!key) return
			if (!map.has(key)) map.set(key, [])
			map.get(key).push(essay)
		})
		return map
	}
}

export const essaySummaryStore = new EssaySummaryStore()
